module.exports = __webpack_public_path__ + "static/media/seminar-image.ae7e08de.jpeg";